module.exports = __webpack_public_path__ + "static/media/1.06f4ede9.jpg";